module.exports = __webpack_public_path__ + "img/1110fc9.jpg";